/**
 * @file PickingStatusBadge.tsx
 * @description Статус задания на сборку (phase19.14, W13; phase19.24 — общий
 * реестр тонов; phase19.31 шаг О4 — реестр статусов кабинета `status-meta`).
 *
 * Подпись и тон берутся из `PICKING_STATUS_META`, а не из ветвления по
 * месту: очередь, карточка задания, сводка склада и блок в заказе красят
 * статус одинаково — «Новое/В работе» синим, «Закрыто» зелёным,
 * «Недостача» и «Отменено» красным (SC26). Прогресс внутрь пилюли не кладём.
 */

import { StatusPill } from "../../ui/StatusPill";
import type { PickingTaskStatus } from "../../../lib/api-picking";
import { PICKING_STATUS_META } from "../../../lib/shop/status-meta";

interface Props {
  status: PickingTaskStatus;
}

export function PickingStatusBadge({ status }: Props) {
  return <StatusPill meta={PICKING_STATUS_META[status]} />;
}
